var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-popup",
    {
      style: { width: "100%", height: "100%" },
      attrs: { position: "bottom", "get-container": "body" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "van-nav-bar",
        {
          staticClass: "navbar",
          on: {
            "click-left": function ($event) {
              _vm.visible = false
            },
          },
        },
        [
          _c("van-icon", {
            attrs: { slot: "left", name: "cross", size: "20" },
            slot: "left",
          }),
          _vm._v(" "),
          _c(
            "van-tabs",
            {
              attrs: { slot: "title", color: "#1989fa" },
              on: { change: _vm.tabChange },
              slot: "title",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _vm.elecseal
                ? _c("van-tab", {
                    attrs: { title: _vm.elecsealText, name: "elecseal" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.esignature
                ? _c("van-tab", {
                    attrs: { title: _vm.esignatureText, name: "esignature" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs-content" },
        [
          _vm.elecseal
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "elecseal",
                      expression: "activeTab === 'elecseal'",
                    },
                  ],
                  staticClass: "tab-panel",
                  class: {
                    "seal-empty": _vm.signatureType != "2" && !_vm.seals.length,
                  },
                },
                [
                  _c(
                    "div",
                    { ref: "elecsealWrapper", staticClass: "elecseal-wrapper" },
                    [
                      _vm.signatureType != "2"
                        ? _vm._l(_vm.seals, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "seal-box",
                                on: {
                                  click: function ($event) {
                                    return _vm.sealsChange(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "seal",
                                    class: {
                                      "seal-selected":
                                        _vm.sealChecked.indexOf(item.WID) > -1,
                                    },
                                  },
                                  [
                                    _c("van-icon", {
                                      staticClass: "seal-icon",
                                      class: {
                                        "seal-icon-checked":
                                          _vm.sealChecked.indexOf(item.WID) >
                                          -1,
                                        "seal-icon-disabled":
                                          _vm.sealChecked.indexOf(item.WID) ==
                                            -1 && _vm.isMultiple,
                                      },
                                      attrs: {
                                        name:
                                          _vm.sealChecked.indexOf(item.WID) > -1
                                            ? "success"
                                            : "circle",
                                        size: "20px",
                                        color: "#dddee1",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("img", { attrs: { src: item.url } }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.esignature
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeTab === "esignature",
                      expression: "activeTab === 'esignature'",
                    },
                  ],
                  staticClass: "tab-panel",
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.esignatureEdit,
                          expression: "!esignatureEdit",
                        },
                      ],
                      staticClass: "esignatrue-box",
                      class: {
                        "esignature-canvas-empty": !_vm.esignatureBegin,
                      },
                    },
                    [_c("canvas", { ref: "canvas" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.esignatureEdit,
                          expression: "esignatureEdit",
                        },
                      ],
                      staticClass: "esignatrue-img",
                    },
                    [
                      _c("img", {
                        ref: "showImg",
                        attrs: { src: _vm.esignatureData },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.elecseal && _vm.activeTab === "elecseal"
            ? _c(
                "van-button",
                {
                  attrs: { type: "info", block: "", disabled: _vm.btnDisabled },
                  on: { click: _vm.useSeals },
                },
                [_vm._v(_vm._s(_vm.confirmText))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.esignature &&
          _vm.activeTab === "esignature" &&
          !_vm.esignatureEdit
            ? _c(
                "van-row",
                { staticClass: "form-add-actions" },
                [
                  _c(
                    "van-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "van-button",
                        {
                          attrs: { block: "" },
                          on: { click: _vm.clearCanvas },
                        },
                        [_vm._v(_vm._s(_vm.clearText))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "van-button",
                        {
                          attrs: { block: "", type: "info" },
                          on: { click: _vm.canvasConfirm },
                        },
                        [_vm._v(_vm._s(_vm.confirmText))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.esignature && _vm.activeTab === "esignature" && _vm.esignatureEdit
            ? _c(
                "van-row",
                { staticClass: "form-add-actions" },
                [
                  _c(
                    "van-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "van-button",
                        { attrs: { block: "" }, on: { click: _vm.editCanvas } },
                        [_vm._v(_vm._s(_vm.editText))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { attrs: { span: "12" } },
                    [
                      _c(
                        "van-button",
                        {
                          attrs: {
                            block: "",
                            type: "info",
                            disabled:
                              (_vm.multiple && _vm.sealChecked.length == 2) ||
                              (!_vm.multiple && _vm.sealChecked.length == 1),
                          },
                          on: { click: _vm.useCanvas },
                        },
                        [_vm._v(_vm._s(_vm.useText))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }